





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import TempList from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box7/temp-list.vue';
@Component({
  components: { TempList },
})
export default class Box1 extends Vue {
  private num: any = 0;
  private deptId: any = '';
  mounted() {
    this.getData({});
  }
  getData(opts: any) {
    const userInfo: any = localStorage.getItem('userInfo');
    const info: any = JSON.parse(userInfo);
    this.deptId = opts.deptId || info.deptId;
    zyScreenServer
      .getTemporaryWorCount({
        topDeptId: this.deptId,
      })
      .then((res: any) => {
        if (res.code === '200' && res.data) {
          this.num = res.data.num;
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  clickNum() {
    const refName = 'TempListRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(this.deptId);
  }
}
